import { FaFolder } from "react-icons/fa";
import { HiOutlineCubeTransparent } from "react-icons/hi";
import { AiOutlineLock } from "react-icons/ai";
import "../../styles/visualization/entryRow.css";
import { useNavigate } from "react-router-dom";

const typeIcons = {
  folder: FaFolder,
  visualization: HiOutlineCubeTransparent,
  publication: HiOutlineCubeTransparent, // backend word mapped
};

const EntryRow = ({
  entry,
  index,
  hovered,
  onHover,
  onLeave,
  currentFolderPath,
}) => {
  const { type, item } = entry;
  const navigate = useNavigate();

  // Normalize type for UI
  const uiType = type === "publication" ? "visualization" : type;
  const Icon = typeIcons[type] || HiOutlineCubeTransparent;

  const handleClick = () => {
    const pathWithoutRoot = currentFolderPath.slice(1); // remove root

    // 📁 Folder navigation
    if (uiType === "folder") {
      navigate(
        `/f/visualizations/${[...pathWithoutRoot, entry.itemId].join("/")}`,
      );
    }

    // 🎬 Visualization navigation
    else if (uiType === "visualization") {
      navigate(
        `/v/visualizations/${[...pathWithoutRoot, entry.itemId].join("/")}`,
      );
    }
  };

  return (
    <div
      className={`folder-entry-row ${hovered ? "hovered" : ""} ${
        !item.description ? "no-desc" : ""
      }`}
      onMouseEnter={onHover}
      onMouseLeave={onLeave}
      onClick={handleClick}
    >
      <div className="folder-entry-index">{index}</div>

      <div className="folder-entry-icon">
        <Icon />
      </div>

      <div className="folder-entry-text">
        <div className="folder-entry-title" title={item.title}>
          {item.title}
        </div>

        {item.description && (
          <div className="folder-entry-description" title={item.description}>
            {item.description}
          </div>
        )}
      </div>
      <div className="folder-entry-badge-container">
        {item?.accessType === "paid" && (
          <AiOutlineLock size={14} className="folder-entry-row-lock" />
        )}
        <div className={`folder-entry-badge folder-entry-badge-${uiType}`}>
          {uiType}
        </div>
      </div>
    </div>
  );
};

export default EntryRow;
